import { mdiClockAlert } from '@mdi/js'

export default {
  title: 'Attendance',
  to: 'attendance-school',
  icon: mdiClockAlert,
  resource: 'AttendanceSchool',
  action: 'read',
}
